import { render, staticRenderFns } from "./PlanetChart.vue?vue&type=template&id=ef9fbd74"
import script from "./PlanetChart.vue?vue&type=script&lang=js"
export * from "./PlanetChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports